<template>
  <div class="rounded-md border-1 border-border-tertiary p-16">
    <NuxtImg
      src="/shop/images/error.svg"
      alt=""
      loading="lazy"
      class="h-52 w-52 image-float"
    />
    <p class="heading-xxs">Att låna kostar pengar!</p>
    <p>
      Om du inte kan betala tillbaka skulden i tid riskerar du en
      betalningsanmärkning. Det kan leda till svårigheter att få hyra bostad,
      teckna abonnemang och få nya lån. För stöd, vänd dig till budget- och
      skuldrådgivningen i din kommun. Kontaktuppgifter finns på
      <NuxtLink
        to="https://www.konsumentverket.se"
        aria-label="länk till konsumentverket"
        target="_blank"
        rel="noopener noreferrer"
      >
        konsumentverket.se.
      </NuxtLink>
    </p>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.image-float {
  float: left;
  margin-right: 6px;
}
</style>
